/** 应用公共枚举值 */

/** 是否枚举 */
export enum YesNo {
  NO = 0,
  YES = 1
}

/** 配置节点类型 */
export enum SysConfigApp {
  TDL = 'tdl', // 无人车
  SYS = 'sys' // 系统
}

/** 配置路径 */
export enum SysConfigPaths {
  TDL = '/tdl',
  DATA_TYPE = '/meta/data_type',
  BUILDING_DICT = '/tdl/dict/buildingNo',
  UNIT_DICT = '/tdl/dict/unitNo',
  ROOM_DICT = '/tdl/dict/roomNo',
  EXPRESS_COMPANY = '/tdl/dict/expressCompany'
}

/** 元数据类型 */
export enum SysConfigMetaType {
  DATA_TYPE = '_meta_data_type' // 设备类型
}

/** 配置状态 */
export enum SysConfigStatus {
  NEW = 0,
  ENABLE = 1,
  DISABLE = 2
}

export enum YN {
  NO = 'N',
  YES = 'Y'
}

export enum YNName {
  'N' = '否',
  'Y' = '是'
}

/** 禁用，启用 */
export enum EnableStatus {
  DISABLE = 0,
  ENABLE = 1
}

/** 站点状态 */
export enum SiteStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

/** 菜单类型 */
export enum DialogType {
  ADD = 0,
  EDIT = 1,
  VIEW = 2
}

/** 推广类型 */
export enum PromotionType {
  ADVERTISE = 'ADVERTISE', // 广告推广
  PRODUCT = 'PRODUCT' // 商品推广
}
export enum PromotionTypeName {
  ADVERTISE = '广告推广', // 广告推广
  PRODUCT = '商品推广' // 商品推广
}

/** 上下架状态 */
export enum ListingStatus {
  ON = 'ON', // 已上架
  OFF = 'OFF' // 已下架
}
export enum ListingStatusName {
  ON = '已上架', // 已上架
  OFF = '已下架' // 已下架
}

/** 生效范围 */
export enum ScopeType {
  ALL_SHOP = 'ALL_SHOP', // 所有门店生效
  LOCATION = 'LOCATION', // 按省市区选择
  PART_SHOP = 'PART_SHOP' // 按门店编号选择
}
export enum ScopeTypeName {
  ALL_SHOP = '所有门店生效', // 所有门店生效
  LOCATION = '按省市区选择', // 按省市区选择
  PART_SHOP = '按门店编号选择' // 按门店编号选择
}

/** 是否有退款 name */
export enum HasRefundName {
  Y = '有退款', // 有退款
  N = '无退款' // 无退款
}

/** 订单状态 */
export enum OrderStatus {
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT', // 待支付
  COMPLETED = 'COMPLETED', // 已完成
  CANCELLED = 'CANCELLED' // 已取消
}
/** 订单状态 name */
export enum OrderStatusName {
  WAITING_FOR_PAYMENT = '待支付', // 待支付
  COMPLETED = '已完成', // 已完成
  CANCELLED = '已取消' // 已取消
}

/** 订单状态 */
export enum PayStatus {
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT', // 待支付
  IN_PAYMENT = 'IN_PAYMENT', // 支付中
  COMPLETE = 'COMPLETE', // 已支付
  FAIL = 'FAIL' // 支付失败
}
/** 订单状态 name */
export enum PayStatusName {
  WAITING_FOR_PAYMENT = '待支付', // 待支付
  IN_PAYMENT = '支付中', // 支付中
  COMPLETE = '已支付', // 已支付
  FAIL = '支付失败' // 支付失败
}

/** 退款状态 */
export enum RefundStatus {
  WAIT_REFUND = 'WAIT_REFUND', // 待退款
  IN_REFUND = 'IN_REFUND', // 退款中
  REFUND_SUCCEED = 'REFUND_SUCCEED', // 退款成功
  REFUND_FAIL = 'REFUND_FAIL' // 退款失败
}
/** 退款状态 name */
export enum RefundStatusName {
  WAIT_REFUND = '未退款', // 待退款
  IN_REFUND = '退款中', // 退款中
  REFUND_SUCCEED = '退款成功', // 退款成功
  REFUND_FAIL = '退款失败' // 退款失败
}

/** 发货单状态 */
export enum ShipmentStatus {
  WAIT_SHIPMENT = 'WAIT_SHIPMENT', // 待发货
  WAIT_INBOUND = 'WAIT_INBOUND', // 待入库
  WAIT_OUTBOUND = 'WAIT_OUTBOUND', // 待出库
  WAIT_CONFIRM_OUTBOUND = 'WAIT_CONFIRM_OUTBOUND', // 待出库确认
  OUTBOUND = 'OUTBOUND', // 已出库
  RETURNED = 'RETURNED', // 已退件
  CLOSED = 'CLOSED' // 已关闭
}

export enum ShipmentStatusName {
  WAIT_SHIPMENT = '待发货', // 待发货
  WAIT_INBOUND = '待入库', // 待入库
  WAIT_OUTBOUND = '待出库', // 待出库
  WAIT_CONFIRM_OUTBOUND = '待出库确认', // 待出库确认
  OUTBOUND = '已出库', // 已出库
  RETURNED = '已退件', // 已退件
  CLOSED = '已关闭' // 已关闭
}

/** 出库类型 */
export enum OutType {
  NORMAL = 'NORMAL', // 正常出库
  RETURN = 'RETURN' // 退件出库
}
export enum OutTypeName {
  NORMAL = '正常出库', // 正常出库
  RETURN = '退件出库' // 退件出库
}

/** 渠道商 */
export enum Distributor {
  'TUXI' = 'DISTRIBUTOR_TUXI_KDG' // 兔喜快递柜
}

/** 模板类型 */
export enum TemplateTypeName {
  DEFAULT = '默认模版', // 默认模版
  HP_850_678 = '横屏850*678模版' // 横屏850*678模版
}

/** 扣款类目 */
export enum DeductionType {
  account = 'BALANCE', // 账户余额
  commission = 'COMMISSION' // 佣金余额
}

/** 扣款原因 - 账户余额 */
export enum DeductionReasonType {
  selfRefund = 'BALANCE_SELF_REFUND', // 自主退款
  violationDeduct = 'BALANCE_VIOLATION_DEDUCT', // 违规扣款
  exitSettlement = 'BALANCE_EXIT_SETTLEMENT', // 退出清算
  offlinePaid = 'COMMISSION_OFFLINE_PAID', // 线下已打款
  commissionViolationDeduct = 'COMMISSION_VIOLATION_DEDUCT', // 佣金违规扣款
  commissionExitSettlement = 'COMMISSION_EXIT_SETTLEMENT' // 佣金退出清算
}

/** RBAC：资源父级模块（根，兼容旧数据） */
export enum RbacParentModule {
  CABINET = 'CABINET', // 营销柜
  CAR = 'CAR', // 无人车
  SETTINGS = 'SETTINGS' // 设置
}

export enum RbacParentModuleName {
  CABINET = '营销柜',
  CAR = '无人车',
  SETTINGS = '设置'
}

/** 资源管理：父级根编码（与后端根资源枚举一致） */
export enum RbacResourceParentCode {
  MARKETING_CABINET = 'MARKETING_CABINET',
  UNMANNED_VEHICLE = 'UNMANNED_VEHICLE',
  SYSTEM = 'SYSTEM'
}

export const RbacResourceParentCodeName: Record<string, string> = {
  [RbacResourceParentCode.MARKETING_CABINET]: '营销柜',
  [RbacResourceParentCode.UNMANNED_VEHICLE]: '无人车',
  [RbacResourceParentCode.SYSTEM]: '系统'
}

/** 资源管理弹窗：新增资源的层级（与树 __treeLevel 对应：1级挂根模块，2级挂1级节点，3级挂1级/2级节点） */
export enum SystemResourceLevel {
  LEVEL_1 = 1,
  LEVEL_2 = 2,
  LEVEL_3 = 3
}

/** RBAC：资源类型 */
export enum RbacResourceType {
  PAGE = 'PAGE' // 页面（预留扩展）
}

export enum RbacResourceTypeName {
  PAGE = '页面'
}

/** RBAC：角色适用端（与 BaseAdminRoleController roleTypes 一致） */
export enum RbacRoleScopeType {
  HEADQUARTERS = 'HEADQUARTERS',
  SUPPLIER = 'SUPPLIER'
}

export const RbacRoleScopeTypeName: Record<string, string> = {
  HEADQUARTERS: '总部角色',
  SUPPLIER: '供应商角色'
}

/** 账号归属（与 BaseAdminAccountController belongType 一致） */
export enum AccountAffiliation {
  HEADQUARTERS = 'HEADQUARTERS',
  SUPPLIER = 'SUPPLIER'
}

export const AccountAffiliationName: Record<string, string> = {
  HEADQUARTERS: '总部',
  SUPPLIER: '供应商'
}

export enum TdlAlarmLevel {
  HIGH = 'HIGH', // 高
  MEDIUM = 'MEDIUM', // 中
  LOW = 'LOW' // 低
}

/** 设备型号 */
export enum TdlDeviceType {
  VEHICLE = 'vehicle', // 整车
  CHASSIS = 'chassis', // 底盘
  TRUNK = 'trunk', // 货仓
  CENTER_CONTROLLER = 'center_controller', // 中控
  ELEVATOR_CONTROLLER = 'elevator_controller' // 梯控
}

/** 设备状态 */
export enum TdlDeviceStatus {
  LOADING_IN_PROGRESS = 'loading_in_progress', // 装货中
  DELIVERY_IN_PROGRESS = 'delivery_in_progress', // 配送中
  UNDER_RECALL = 'under_recall', // 召回中
  CHARGING = 'charging', // 充电中
  STOPPED = 'stopped' // 已停机
}

/** 设备状态 */
export enum TdlDeviceOrderStatus {
  ALREADY_LOADED = 'already_loaded', // 装货中
  DELIVERING = 'delivering', // 配送中
  DELIVERED = 'delivered', // 召回中
  WAITING = 'waiting', // 充电中
  CANCEL = 'cancel' // 已停机
}

/** 设备状态 */
export enum TdlOnlineStatus {
  ONLINE = 'ONLINE', // 在线
  OFFLINE = 'OFFLINE' // 离线
}

/** 设备SN状态 */
export enum TdlDeviceSNStatus {
  UNUSED = 'UNUSED', // 已使用
  EXPORTED = 'EXPORTED', // 已导出
  ACTIVATED = 'ACTIVATED', // 已激活
  VOIDED = 'VOIDED' // 已作废
}

/** 订单状态 */
export enum TdlOrderStatus {
  ALREADY_LOADED = 'already_loaded', // 已装货
  DELIVERING = 'delivering', // 配送中
  DELIVERED = 'delivered', // 已送达
  WAITING = 'waiting', // 等待中
  CANCEL = 'cancel' // 已取消
}

/** 订单状态 */
export enum TdlOrderInboundStatus {
  NOP = 'NOP', // 未推送
  PENDING = 'PENDING', // 推送中
  SUCCESS = 'SUCCESS', // 推送成功
  FAILED = 'FAILED' // 推送失败
}

export enum TdlOptLogModule {
  ORDER = 'ORDER', // 订单模块
  DEVICE_RUN = 'DEVICE_RUN', // 设备运行模块
  ORDER_LOGISTICS = 'ORDER_LOGISTICS' // 物流轨迹
}

/** 操作日志类型 */
export enum TdlOptLogType {
  ADD = 'ADD', // 添加
  UPDATE = 'UPDATE', // 更新
  DELETE = 'DELETE', // 删除
  IMPORT = 'IMPORT', // 导入
  LOGIN = 'LOGIN', // 登录

  VOID = 'VOID', // 作废
  RESTORE = 'RESTORE', // 恢复

  //region 站点
  ENABLED = 'ENABLE', // 启用
  DISABLED = 'DISABLE', // 禁用
  //endregion 站点

  // 设备指令类型
  CALL_BACK = 'CALL_BACK', // 召回
  REBOOT = 'REBOOT', // 重启
  STOP = 'STOP', // 停止
  DEPARTURE = 'DEPARTURE', // 发车
  OPEN = 'OPEN', // 开门
  CLOSE = 'CLOSE' // 关门
}

/** 出库类型 */
export enum OrderChannel {
  THIRD_PARTY = 'THIRD_PARTY', // 三方
  TUDA = 'TUDA' // 兔哒
}

export enum OrderChannelName {
  THIRD_PARTY = '三方', // 三方
  TUDA = '兔哒' // 兔哒
}
